export enum IconSize {
  Default = 'default',
  Large = 'large',
}
